export default __webpack_public_path__ + "static/media/higherLevelImage.0de5ef48.png";